import { createClient } from '@supabase/supabase-js'
import { createCookieStorage } from './cookie-storage.js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY env vars')
}

// Store the auth session in a cookie scoped to the parent domain so the blog
// (aicodingpatterns.com) and learn (learn.aicodingpatterns.com) share login.
// VITE_COOKIE_DOMAIN = ".aicodingpatterns.com" in prod; unset in dev (host-only
// cookie on localhost). Implicit flow is kept (no flowType override) so
// email-confirm / OTP / OAuth behavior is unchanged — only storage moves from
// localStorage to a cookie. storageKey is an explicit shared literal so both
// apps read/write the SAME cookie.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: createCookieStorage({
      domain: import.meta.env.VITE_COOKIE_DOMAIN || undefined,
      // Gate Secure on the real protocol, not the build mode: a prod-mode build
      // served over http://localhost (e.g. vite preview) would otherwise set
      // Secure and the browser would silently drop the session cookie.
      secure: typeof location !== 'undefined' && location.protocol === 'https:',
    }),
    storageKey: 'sb-acp-auth',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
